<template>
  <div class="col-12 px-0">
    <div class="mt-n2">
      <b-table
        borderless
        hover
        responsive
        table-variant="white text-info"
        :fields="fields"
        :items="filteredItems"
        :small="$root.isMobile"
      >
        <template #cell(survey_name)="row">
          <p class="mb-0 text-secondary text-justify text-capitalize fw-bolder">
            {{ row.item.survey_name }}
          </p>
        </template>

        <template #cell(survey_activity_name)="row">
          <p class="mb-0 text-secondary text-justify fw-bolder">
            {{ row.item.survey_activity_name }}
          </p>
        </template>

        <template #cell(filled_survey_count)="row">
          <p class="mb-0 text-secondary text-center fw-bolder">
            {{ row.item.filled_survey_count }}
          </p>
        </template>

        <template #cell(is_survey_active)="row">
          <b-icon
            icon="circle-fill"
            :variant="row.item.is_survey_active ? 'success' : 'danger'"
          />
        </template>
      </b-table>

      <p v-if="!filteredItems.length" class="mt-3">
        Nessun questionario trovato
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DettaglioAziendaTabellaQuestionari",
  props: {
    lista: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      fields: [
        {
          key: "survey_name",
          label: "Nome",
          class: "text-justify",
          tdClass: "text-truncate"
        },
        {
          key: "survey_activity_name",
          label: "Attività",
          class: "text-justify",
          tdClass: "text-truncate",
          thStyle: { width: "35%" }
        },
        {
          key: "filled_survey_count",
          label: "Compilazioni",
          class: "text-center",
          tdClass: "text-center",
          thStyle: { width: "16%" }, 
          sortable: true
        },
        { key: "is_survey_active", label: "Attivo" }
      ]
    }
  },
  computed: {
    filteredItems() {
      const term = this.search?.toLowerCase() ?? ""
      if (!term) return this.lista
      return this.lista.filter(
        (q) =>
          q.survey_name.toLowerCase().includes(term) ||
          (q.survey_activity_name ?? "").toLowerCase().includes(term)
      )
    }
  }
}
</script>

<style scoped>
.text-truncate {
  max-width: 230px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
